module.exports = __webpack_public_path__ + "assets/932365562011a5fb3cb370ba65c0b5a0.png";